/*
 * Export jQuery into window.$ and window.jQuery because bootstrap component
 * do not require it as node_module but search it in global space.
 */
window.jQuery = require('jquery');

window.$ = window.jQuery;
// Activate Bootstrap bindings for dropdowns, modals and so.
require('bootstrap');

window.$(document).ready(() => {
  const { $ } = window;

  // Toggle vertical accordions on user panels. Also change icon on it.
  $(document).on('click', '.btn-switcher', function() {
    $('article.accordion section').toggleClass('acc-close');
    $(this).find('.fa-caret-square-o-left, .fa-caret-square-o-right');
  });

  $(document).on('click', 'label.f-activity span', function() {
    $(this)
      .find('.fa-cogs')
      .toggleClass('active');
    $('.block').toggleClass('show');
  });
});
